// src/tokens/colors/primitiveColor.ts
var primitiveColor = {
  neutral: {
    0: "#FFFFFF",
    5: "#F6F9FA",
    10: "#F2F6F8",
    20: "#E4EBF0",
    30: "#D7E0E6",
    40: "#C7D2D8",
    50: "#9DA7AE",
    60: "#81898F",
    70: "#5F666B",
    80: "#3A3E41",
    90: "#25282A",
    95: "#1D2021",
    100: "#141617"
  },
  deepRed: {
    5: "#FFF8F7",
    10: "#FCEEED",
    20: "#FCD8D7",
    30: "#FDA5A2",
    40: "#FC7E79",
    50: "#F75A54",
    60: "#EB3E38",
    70: "#DE1912",
    80: "#B21712",
    90: "#8A120E",
    100: "#700F0B"
  },
  red: {
    5: "#FFF8F7",
    10: "#FFEFED",
    20: "#FFDFDB",
    30: "#FFC8C2",
    40: "#FFA399",
    50: "#FF7A6B",
    60: "#FF5542",
    70: "#F73620",
    80: "#E31700",
    90: "#C71704",
    100: "#941103"
  },
  orange: {
    5: "#FFF9F5",
    10: "#FFF0E5",
    20: "#FFE3CF",
    30: "#FFD0AD",
    40: "#FFBE8F",
    50: "#FF9C57",
    60: "#FF8026",
    70: "#FA6700",
    80: "#DE4A00",
    90: "#C24700",
    100: "#8F3400"
  },
  yellow: {
    5: "#FFF9F0",
    10: "#FFF6E5",
    20: "#FFEAC7",
    30: "#FFDEA6",
    40: "#FFCE7A",
    50: "#FFBE4D",
    60: "#FFAB24",
    70: "#FF9900",
    80: "#E58200",
    90: "#BA6900",
    100: "#874D00"
  },
  green: {
    5: "#F5FFF5",
    10: "#EBFFEB",
    20: "#CFFCCF",
    30: "#ACF2AC",
    40: "#96EB96",
    50: "#79E079",
    60: "#55D455",
    70: "#27C227",
    80: "#099E09",
    90: "#008000",
    100: "#185218"
  },
  mint: {
    5: "#F5FFFE",
    10: "#E5FFFD",
    20: "#BEFAF4",
    30: "#A0F2EA",
    40: "#82E8DE",
    50: "#5BE3D1",
    60: "#1ED4C1",
    70: "#00C7B3",
    80: "#00AD9D",
    90: "#009183",
    100: "#005E55"
  },
  blue: {
    5: "#F7FBFF",
    10: "#EDF6FF",
    20: "#D4EAFF",
    30: "#B2DAFF",
    40: "#8FC9FF",
    50: "#5CB1FF",
    60: "#2998FF",
    70: "#0085FF",
    80: "#006ACC",
    90: "#004F99",
    100: "#003566"
  },
  deepBlue: {
    5: "#F7F9FF",
    10: "#EDF1FC",
    20: "#D3DDFC",
    30: "#A7BBFC",
    40: "#7998FC",
    50: "#597EF7",
    60: "#3B66F5",
    70: "#2654EB",
    80: "#173BB2",
    90: "#122E8A",
    100: "#0F2775"
  },
  purple: {
    5: "#F9F7FF",
    10: "#F3F0FF",
    20: "#E1DBFF",
    30: "#CCC2FF",
    40: "#B2A3FF",
    50: "#9985FF",
    60: "#846BFF",
    70: "#6E50FF",
    80: "#4E35CC",
    90: "#402E99",
    100: "#2A1F66"
  },
  pink: {
    5: "#FFF7F8",
    10: "#FFEDF0",
    20: "#FFD6DC",
    30: "#FFBAC4",
    40: "#FF94A4",
    50: "#FF7086",
    60: "#FA5069",
    70: "#E8344E",
    80: "#D1213B",
    90: "#BD172F",
    100: "#8A1122"
  },
  neutralWhiteAlpha: {
    0: "#FFFFFF00",
    8: "#FFFFFF14",
    12: "#FFFFFF1F",
    20: "#FFFFFF33"
  },
  neutralBlackAlpha: {
    0: "#14161700",
    60: "#14161799"
  },
  neutralBlueAlpha: {
    8: "#00356614",
    12: "#0035661F",
    15: "#00356626"
  }
};

export {
  primitiveColor
};
